import { render, staticRenderFns } from "./RouteShow.vue?vue&type=template&id=3d8345a7"
import script from "./RouteShow.vue?vue&type=script&lang=js"
export * from "./RouteShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports